import { useQuery } from '@tanstack/react-query';
import { appointmentCancellationDetailsByIdBatch } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useAppointmentCancellationDetailsQuery = (appointmentId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'appointment', appointmentId, 'cancellationDetails' ],
    queryFn: () => appointmentCancellationDetailsByIdBatch.fetch(appointmentId),
    staleTime: Infinity,
    ...opts,
  });
};
